module.exports = __webpack_public_path__ + "img/bg1.feb2c556.png";